import React from 'react'
import { Routes, Route } from 'react-router-dom';
import 'animate.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './css/Admin/Sidebar.css';

// gen imports
import Header from './general/Header.js';
import Footer from './general/Footer.js';
import PageNotFound from './general/PageNotFound.js';
import ScrollTop from './general/ScrollTop.js';

// page imports
import Home from './components/Home.js';
import About from './components/About.js';
import Contact from './components/Contact.js';
import PrivacyPolicy from './components/PrivacyPolicy.js';
import AdminLogin from './Admin/AdminLogin.js';


// admin imports
import Sidebar from './Admin/Sidebar.js';
import Dashboard from './Admin/Dashboard.js';
import ViewUsers from './Admin/ViewUsers.js';
import SubscriptionPlan from './Admin/SubscriptionPlan.js';
import SiteEnquiry from './Admin/SiteEnquiry.js';
import EduTopics from './Admin/EduTopics.js';
import ManageProfile from './Admin/ManageProfile.js';
import MyInsights from './Admin/MyInsights.js';
import News from './Admin/News.js';
import ChannelList from './Admin/ChannelList.js';
import UserPlanHistory from './Admin/UserPlanHistory.js';


const App = () => {
    const userData = JSON.parse(localStorage.getItem('userData'));
  const collapsed = false;

  return (
    <>

          <ScrollTop />
<ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
      />
      
{userData == null && (
  <>
<Header />


    <Routes>
              <Route exact path='/' element={<Home />} />
              <Route exact path='/about' element={<About />} />
              <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route exact path='/contact' element={<Contact />} />
              <Route exact path='/admin-login' element={<AdminLogin />} />
        <Route exact path='*' element={<PageNotFound />} />
    </Routes>
<Footer />
</>)}


{userData != null && (
<>
            <Sidebar />
                      <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>
    <Routes>
                    <Route exact path='/' element={<Dashboard />} />
                    <Route exact path='/manage-profile' element={<ManageProfile userData={userData} />} />
                    <Route exact path='/view-users' element={<ViewUsers userData={userData} />} />
                    <Route exact path='/subscriptions' element={<SubscriptionPlan userData={userData} />} />
                    <Route exact path='/educational-links' element={<EduTopics userData={userData} />} />
                    <Route exact path='/my-insights' element={<MyInsights userData={userData} />} />
                    <Route exact path='/news' element={<News userData={userData} />} />
                    <Route exact path='/channel-list' element={<ChannelList userData={userData} />} />
                    <Route exact path='/site-enquiry' element={<SiteEnquiry userData={userData} />} />
                    <Route exact path='/user-plan-history' element={<UserPlanHistory userData={userData} />} />
        <Route exact path='*' element={<PageNotFound />} />
</Routes>
</div>
</>)}

    </>
  )
}

export default App